// extracted by mini-css-extract-plugin
export default {"Divider":"📚19-10-2_q2yX"};